
/*global Server*/
import { defineComponent } from 'vue';
import { Form, Field } from "vee-validate";
import * as yup from "yup";
import { AxiosError, AxiosResponse } from 'axios';
import { useProgrammatic } from '@oruga-ui/oruga-next';
import { useUserStore } from './../../stores/user';
import { useRouter } from 'vue-router';

export default defineComponent({
    components: {
        Form,
        Field
    },
    props: {
        partial: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        const { oruga } = useProgrammatic();

        const router = useRouter();

        function successToast() {
            oruga.notification.open({
                message: 'Successfull Login!',
                rootClass: 'toast-notification',
                position: 'top',
                duration: 5000,
                variant: 'success'
            });
        }

        function failureToast(errorMessage: string) {
            oruga.notification.open({
                message: `${errorMessage}`,
                rootClass: 'toast-notification',
                position: 'top',
                variant: 'danger',
                duration: 10000,
                closable: true
            });
        }

        const userStore = useUserStore();

        return {
            successToast,
            failureToast,
            userStore,
            router,
            form: {
                Username: '',
                Password: ''
            } as Server.ILoginForm,
            user: {} as Server.IUser,
            isLoginPageLoading: false as boolean,
            errorMessage: '',
        }
    },
    computed: {
        schema(): object {
            return yup.object().shape({
                form: yup.object({
                })
            });
        }
    },
    methods: {
        onSubmit(): void {
            this.isLoginPageLoading = true;
                const portalURL = process.env.VUE_APP_PORTAL_BASE_URL;

                this.$axios.post('/api/Account/Login', this.form, { baseURL: portalURL})
                .then((response: AxiosResponse<any>) => {
                    if (response.status == 200) {

                        if (typeof response.data === 'string') {
                            this.router.push('/reset-password?Token=' + response.data);
                        } else {
                            this.errorMessage = '';
                            this.successToast();

                            this.userStore.$patch({
                                user: {
                                    EmailAddress: response.data.EmailAddress,
                                    Id: response.data.Id,
                                    FirstName: response.data.FirstName,
                                    LastName: response.data.LastName,
                                    Suffix: response.data.Suffix,
                                    Permissions: response.data.Permissions,
                                }
                            });
                            this.$router.push({ name: 'checkout' })
                        }

                    } else { //present errors logging in
                        this.failureToast("Error logging in");
                    }
                })
                .catch((error: AxiosError) => {
                    if (error.response && error.response.status === 401) {
                        this.errorMessage = 'Invalid username or password.';
                    } else {
                        this.errorMessage = 'An error occurred during login.';
                    }
                    this.failureToast(this.errorMessage);
                })
                .finally(() => {
                    this.isLoginPageLoading = false;
                });
        },
        clearfields(): void {
            (this.$refs.formValidator as any).resetForm();
        },
    }
});
